import React from 'react';

import Button from '../../../components/main/buttons/Button/Button';

import './FreeConsultation.css';

const FreeConsultation = () => {
  return (
    <div className='free-consultation-page-container'>
      <div className='free-consultation-title-container'>
        <h1 className='free-consultation-title'>GET FREE CONSULTATION</h1>
      </div>
      <div className='free-consultation-content-container'>
        <p className='free-consultation-text'>
          Have a quick chat with a therapist
        </p>
        <p className='free-consultation-text'>
          Find the best treatment option for you
        </p>
        <div className='free-consultation-btn-container'>
          <Button href='https://proevolutionwellness.janeapp.com/'>
            Book Free Consultation
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FreeConsultation;
